export const CanvasSVGObjectContentType = {
  StickyNote: 'StickyNote',
  Whiteboard: 'Whiteboard',
};
